var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.686 4.167.698-.716-.719-.702-.698.723.719.695ZM2.225 16.02l-.72-.695-.202.21-.058.285.98.2ZM6.9 20.703l.093.996.366-.034.257-.263-.716-.699ZM18.478 8.845l.715.698.699-.715-.716-.699-.698.716ZM1.155 21.238l-.98-.2a1 1 0 0 0 1.073 1.196l-.093-.996Zm11.81-17.766L1.507 15.326l1.437 1.39L14.405 4.862l-1.438-1.39Zm-5.35 17.93L19.193 9.543l-1.431-1.397L6.185 20.005l1.43 1.397Zm11.56-13.273-4.792-4.678-1.397 1.431L17.78 9.56l1.397-1.43ZM1.245 15.821.176 21.038l1.96.401 1.068-5.217-1.96-.401Zm.004 6.413 5.744-.535-.186-1.991-5.744.535.186 1.991Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m13.979 3.952 1.546-1.584a3.31 3.31 0 0 1 4.736 4.624l-1.546 1.584-4.736-4.624Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/edit-icon-white.ef6e358911e93f2d28b7cac147db2849.svg";
export { ForwardRef as ReactComponent };